import '../App.css';
import React from 'react';
import Header2 from '../Component/Header';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { connect } from 'react-redux'
import Moment from 'moment-timezone';
import Table from 'react-bootstrap/Table';
import { language } from '../language';
import { Button } from 'react-bootstrap';
import { Platformcolor } from '../static/PlatformColor';

const { getAllSalesBSA1, ZD_getAllSalesBSA1 } = require('../Api');
const utilizeScroll = () => {
  
  const elRef = React.createRef();
  const executeScroll = () => elRef.current.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});

  return { executeScroll, elRef };
};

class Page2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Username: this.props.username,
      SelectedDate: Moment(new Date()).toDate(),
      GameArray: [[], [], [], [], [], [], [], []],
      MinimumType: 'B,S,SA,SB,SC',
      ObjectKeys: ['1','2','3','4','5','6','7','8'],
      LoadingPage: false,
      hideDadi: true,
      add102words: true,
    }
    this.elScroll = utilizeScroll();
  }

  async componentDidMount(){
    this.CallAPI()
  }

  async CallAPI(){
    this.setState({ LoadingPage: true })
    
    const GameArray = await getAllSalesBSA1(Moment(this.state.SelectedDate).format('YYYY-MM-DD'), this.state.hideDadi, this.props.username, this.props.token)
    if (GameArray.error) {
      this.setState({ GameArray: JSON.parse(JSON.stringify(GameArray.error)), LoadingPage: false})
      return
    }
    if (this.state.add102words) {
      const GameArrayToSet = JSON.parse(JSON.stringify(GameArray)) 
      const zdGameArray = await ZD_getAllSalesBSA1(Moment(this.state.SelectedDate).format('YYYY-MM-DD'), this.state.hideDadi, this.props.username, this.props.token)
      const gamearrayfor = ['1', '2', '3', '4', '5', '6', '7', '8']
      for(let i = 0; i < gamearrayfor.length; i += 1) {
        const thisgamearray = zdGameArray[i]
        for(let j = 0; j < thisgamearray.length; j += 1) {
          const thiswordindex = GameArray[i].findIndex((item) => item.Word === thisgamearray[j].Word)
          if (thiswordindex === -1) {
            GameArrayToSet[i].push(thisgamearray[j])
          } else {
            GameArrayToSet[i][thiswordindex].total_BS += thisgamearray[j].total_BS
            GameArrayToSet[i][thiswordindex].B += thisgamearray[j].B
            GameArrayToSet[i][thiswordindex].S += thisgamearray[j].S
            GameArrayToSet[i][thiswordindex].SA += thisgamearray[j].SA
          }
        }
        GameArrayToSet[i] = GameArrayToSet[i].sort((a, b) => b.total_BS - a.total_BS);
      }
      this.setState({ GameArray: GameArrayToSet, LoadingPage: false })
    } else {
      this.setState({ GameArray, LoadingPage: false })
    }
  }

  async setSelectedDate(SelectedDate) {
    this.setState({ SelectedDate })
  }

  render() {
    return (
      <div style={{ width: '100%', height: '100vh', flexDirection: 'column', overflowY: 'auto' }}> 
        <Header2 />
        {this.state.LoadingPage && 
        <>
          <div className='dcc' style={{ fontWeight: 'bold', fontSize: 30, height: '80vh'}}>{language[this.props.currentLanguage].Loading}</div>
        </>}
        {this.state.LoadingPage === false && 
        <>
          <div style={{ marginLeft: 10, flexDirection: 'row', display: 'flex', alignItems: 'center'}}>
            <div style={{ alignItems: 'center', display: 'flex' }} >
              <div style={{fontSize: "18px", width: 80, textAlign: 'left'}}>{language[this.props.currentLanguage].Date} :</div>
              <DatePicker
                onChange = {(Date) => this.setSelectedDate(Date)}
                dateFormat = 'dd-MMM-yyyy'
                placeholder="Date"
                selected={this.state.SelectedDate}
                className={"form-control StyleDatePicker"}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 20}}>
              <div style={{ marginRight: 5 }}>扣减打钉</div>
              <input 
                type='checkbox' 
                checked={this.state.hideDadi}
                onChange={() => {this.setState(prevState => ({
                  hideDadi : !prevState.hideDadi}
                ))}}
                style={{height: 20, width: 20}}
              />
              <div style={{ marginLeft: 30, marginRight: 5 }}>增加102打字</div>
              <input 
                type='checkbox' 
                checked={this.state.add102words}
                onChange={() => {this.setState(prevState => ({
                  add102words : !prevState.add102words}
                ))}}
                style={{height: 20, width: 20}}
              />
              <Button className="button2" style={{ marginLeft: 30}} onClick={() => {
                this.CallAPI()
              }}>Refresh</Button>
            </div>
          </div>
          <div style={{ marginLeft: 10, flexDirection: 'row', display: 'flex'}}>
            {this.state.ObjectKeys.map((item, index) => {
              return this.state.GameArray[index].length > 0 && <div key={index} style={{ width: 320, marginRight: 10 }}><Table>
                <thead>
                  <tr style={{backgroundColor: Platformcolor(item, ''), color: (item === '1') ? 'black' : (item === '7') ? 'black' : (item === '4') ? 'black' : 'white'}} >
                    <th colSpan={5} ><div style= {{ fontSize: 15}}>{
                      (item === '1') ? `${language[this.props.currentLanguage].magnum}` 
                        : (item === '2') ? `${language[this.props.currentLanguage].damacai}`
                          : (item === '3') ? `${language[this.props.currentLanguage].toto}`
                            : (item === '4') ? `${language[this.props.currentLanguage].singapore}`
                              : (item === '5') ? `${language[this.props.currentLanguage].sarawak}`
                                : (item === '6') ? `${language[this.props.currentLanguage].sabah}`
                                  : (item === '7') ? `${language[this.props.currentLanguage].sandakan}`
                                    : `${language[this.props.currentLanguage].america}` }</div></th>
                  </tr>
                </thead>
                <thead>
                  <tr>
                    <th style={{ width: 50 }}><div>Number</div></th>
                    <th style={{ width: 50 }}><div>B+S</div></th>
                    <th style={{ width: 50 }}><div>B</div></th>
                    <th style={{ width: 50 }}><div>S</div></th>
                    <th style={{ width: 50 }}><div>SA</div></th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.GameArray[index].map((NumberItem, ind) =>{
                    return <tr key={ind}>
                      <th style={{ backgroundColor: '#9AFFF0'}} >{NumberItem.Word}</th>
                      <th>{NumberItem.Amount === 0 ? '-' : NumberItem.total_BS.toFixed(0)}</th>
                      <th style={{ backgroundColor: '#FFF4AE'}}>{NumberItem.B === 0 ? '-' : NumberItem.B.toFixed(0)}</th>
                      <th>{NumberItem.S === 0 ? '-' : NumberItem.S.toFixed(0)}</th>
                      <th style={{ backgroundColor: '#FFA5A5'}}>{NumberItem.SA === 0 ? '-' : NumberItem.SA.toFixed(0)}</th>
                    </tr>
                  })}
                </tbody>
              </Table></div>
            })}
          </div>
        </>
        }
      </div >
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    userID: state.userID,
    username: state.username,
    token: state.token,
    Role: state.Role,
    UserAuthority: state.UserAuthority,
    currentLanguage: state.currentLanguage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setDate: (Date) => {
      dispatch({
        type: 'SELECTED_DATE',
        payload: Date,
      });
    },
    setLanguage: (lg) => {
      dispatch({ type: 'SET_LANGUAGE', payload: lg });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Page2);